import {makeStyles} from "@material-ui/core/styles";
import RedirectBackground from '../../assets/images/redirect-background.jpg'

export const useRedirectStyles = makeStyles((theme) => ({
    root: {
        backgroundImage: `url(${RedirectBackground})`,
        backgroundPositionX: "center",
        backgroundPositionY: "center",
        height: "100vh"
    },
    boxWrapper: {
        position: "fixed",
        top: "20%",
        left: "50%",
        transform: "translate(-50%, -15%)",
        width: "40%",
        height: "400px",
        [theme.breakpoints.down('sm')]: {
            width: "80%"
        },
    },
    card: {
        backgroundColor: "rgba(255,255,255, 0.8)",
        marginTop: "40px",
        borderRadius: "10px",
        padding: "32px"
    },
    progress: {
        textAlign: 'center',
        marginTop: "1.5em"
    },
    title: {
        marginBottom: "1em"
    }
}));
